import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default function () {
  const timeline = document.querySelector('.Timeline')
  if (!timeline) return null

  const centerLine = timeline.querySelector('.Timeline__CenterLine')
  const centerBar = timeline.querySelector('.Timeline__CenterBar')
  const centerYears = gsap.utils.toArray('.Timeline__CenterYear')
  const years = gsap.utils.toArray('.Timeline__Year')
  const mediaEls = gsap.utils.toArray('.Timeline__Media')

  gsap.registerPlugin(ScrollTrigger)
  initScroll()

  function initScroll() {
    // Clickable centre years → scroll to matching timeline year
    centerYears.forEach((label) => {
      const yearValue = label.dataset.year || label.textContent.trim()
      if (!yearValue) return

      const target =
        timeline.querySelector(`.Timeline__Year[id='${yearValue}']`) ||
        timeline.querySelector(`.Timeline__Year[data-year='${yearValue}']`)

      if (!target) return

      label.addEventListener('click', (event) => {
        event.preventDefault()
        target.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    })

    // Center line activation and progress
    if (centerLine && centerBar) {
      const totalYears = centerYears.length || 1

      ScrollTrigger.create({
        trigger: timeline,
        start: 'top top',
        end: 'bottom+=400px bottom',
        onEnter: () => timeline.classList.add('is-active'),
        onEnterBack: () => timeline.classList.add('is-active'),
        onLeave: () => timeline.classList.remove('is-active'),
        onLeaveBack: () => timeline.classList.remove('is-active'),
        onUpdate: (self) => {
          const clamped = Math.min(Math.max(self.progress, 0), 1)
          const progress = clamped * 100

          // Grow the yellow fill bar
          centerBar.style.setProperty('--line-progress', `${progress}%`)

          // As the line progresses, highlight centre years that have been "passed"
          centerYears.forEach((label, index) => {
            // Distribute thresholds evenly from 0 → 100
            const threshold =
              totalYears === 1 ? 100 : (index / (totalYears - 1)) * 100

            if (progress >= threshold) {
              label.classList.add('is-active')
            } else {
              label.classList.remove('is-active')
            }
          })
        },
      })
    }

    // Opacity, position and video ScrollTriggers per year
    years.forEach((year, index) => {
      const video = year.querySelector('.Timeline__Media')
      const copy = year.querySelector('.Timeline__Text')

      // If structure is unexpected, fall back to animating the whole year
      if (!video || !copy) {
        gsap.set(year, { opacity: 0, xPercent: 0 })
        gsap.to(year, {
          opacity: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: year,
            start: 'top 90%',
            end: 'top 40%',
            scrub: 1,
          },
        })
      } else {
        // On desktop, one column sits left of the centre line and one right.
        // We want the left column to slide in from the left,
        // and the right column to slide in from the right.
        //
        // For odd/even years the video/copy swap sides, so we flip directions.

        let mql = window.matchMedia('(width >= 960px)')
        const isEven = index % 2 === 0

        let videoFrom, copyFrom

        console.log(mql.matches)

        if (mql.matches) {
          videoFrom = isEven ? -20 : 20 // percentage of width
          copyFrom = isEven ? 20 : -20
        } else {
          videoFrom = 20 // percentage of width
          copyFrom = 20
        }

        gsap.set(video, { opacity: 0, xPercent: videoFrom })
        gsap.set(copy, { opacity: 0, xPercent: copyFrom })

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: year,
            start: 'top 90%',
            end: 'top 40%',
            scrub: 1,
            // markers: true,
          },
        })

        tl.to(
          video,
          {
            opacity: 1,
            xPercent: 0,
            ease: 'none',
          },
          0,
        ).to(
          copy,
          {
            opacity: 1,
            xPercent: 0,
            ease: 'none',
          },
          0,
        )
      }
    })
  }
}
